import { Link } from 'react-router-dom';
import { Button } from '@dreamtree-org/twreact-ui';

export default function Unauthorized() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-6 text-center bg-[var(--app-bg)]">
      <div className="text-4xl font-bold text-warning-600">Access denied</div>
      <p className="text-secondary-500">You don’t have permission to view this page.</p>
      <Link to="/"><Button variant="outline">Back to dashboard</Button></Link>
    </div>
  );
}
